module.exports = __webpack_public_path__ + "img/najib.934d04e7.jpg";